/**
 * Created by Alex Aguilar on 3/31/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('modelAircraftsController', modelAircraftsController)
        .controller('newEditModelAircraftController', newEditModelAircraftController)
        .controller('flightTimeModelAircraftCtrl', flightTimeModelAircraftCtrl)
        .controller('deleteModelAircraftController', deleteModelAircraftController)
        .controller('modalAddMakerController', modalAddMakerController);

    modelAircraftsController.$inject = ['tabs', 'modelAircrafts'];
    newEditModelAircraftController.$inject = ['tabs', 'modelAircraft', 'makers', '$uibModal', 'makerService', 'modelAircraftService'];
    deleteModelAircraftController.$inject = ['$uibModalInstance', 'modelAircraft', 'modelAircraftService'];
    modalAddMakerController.$inject = ['$uibModalInstance', 'makerService'];
    flightTimeModelAircraftCtrl.$inject = ['$stateParams', 'flightTimeService', 'timeService','modelAircraft',
        'flightTimes','takeOffCapacities', 'toastr', '$translate'];

    function modelAircraftsController(tabs,modelAircrafts) {
        var vm = this;
        vm.tabs = tabs;
        vm.pages = [];
        vm.modelAircrafts = (modelAircrafts.data._embedded) ? modelAircrafts.data._embedded.modelAircrafts : [];
        vm.pages = modelAircrafts.data.page;
    }

    function newEditModelAircraftController(tabs, modelAircraft, makers, $uibModal, makerService, modelAircraftService){
        var vm = this;
        vm.tabs = tabs;
        vm.widthStep = 100 / 2;
        vm.makers = (makers.data._embedded) ? makers.data._embedded.makers : [];
        vm.categories = [
            {'name': 'air.modelAircraft.light', 'initials': 'L'},
            {'name': 'air.modelAircraft.medium', 'initials': 'M'},
            {'name': 'air.modelAircraft.heavy', 'initials': 'H'}
        ];

        vm.formValid = false;
        vm.action = (modelAircraft != null) ? "edit" : "new";

        if(modelAircraft != null){
            vm.modelAircraft = modelAircraft.data;
            vm.old = angular.copy(vm.modelAircraft);
            vm.buttonSave = true;
            vm.isDisabled = true;
        } else {
            vm.modelAircraft = {
                makerId: null
            };
            vm.isDisabled = false;
        }

        vm.getMakers = function (maker) {
            makerService.getMakers()
                .then(function (response) {
                    vm.makers = (response.data._embedded) ? response.data._embedded.makers : [];
                    vm.modelAircraft.makerId = maker.makerId;
                });
        }

        vm.AddMaker = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/configGeneral/aircraft/maker/modalAddMaker.html',
                controller: 'modalAddMakerController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(function (responseMaker) {
                vm.getMakers(responseMaker.maker);
            }, function () {
            });
        };

        vm.saveModelAircraftStep2 = function(isValid, modelAircraft){
            if (isValid) {
                modelAircraft.capacity = parseInt(modelAircraft.capacity);
                modelAircraft.length = parseInt(modelAircraft.length);
                modelAircraft.wingspan = parseInt(modelAircraft.wingspan);
                if(vm.action === "new"){
                    modelAircraftService.saveModelAircraft(modelAircraft);
                }else{
                    modelAircraftService.updateModelAircraft(modelAircraft);
                }
            }
        }

        vm.change = function(){
            if(vm.action == "edit"){
                if(vm.modelAircraft.makerId!=undefined&&vm.modelAircraft.makerId==vm.old.makerId&&
                    vm.modelAircraft.name.toUpperCase()==vm.old.name.toUpperCase() &&
                    vm.modelAircraft.capacity==vm.old.capacity &&
                    vm.modelAircraft.iataCode.toUpperCase()==vm.old.iataCode.toUpperCase() &&
                    vm.modelAircraft.icaoCode.toUpperCase()==vm.old.icaoCode.toUpperCase() &&
                    vm.modelAircraft.category!=undefined && vm.modelAircraft.category==vm.old.category &&
                    vm.modelAircraft.length==vm.old.length && vm.modelAircraft.wingspan==vm.old.wingspan &&
                    vm.modelAircraft.height==vm.old.height && vm.modelAircraft.wingProfile==vm.old.wingProfile &&
                    vm.modelAircraft.wingArea==vm.old.wingArea && vm.modelAircraft.emptyWeight==vm.old.emptyWeight &&
                    vm.modelAircraft.loadedWeight==vm.old.loadedWeight && vm.modelAircraft.totalWeight==vm.old.totalWeight &&
                    vm.modelAircraft.maximumWeight==vm.old.maximumWeight && vm.modelAircraft.maximumVolume==vm.old.maximumVolume){
                    vm.buttonSave = true;
                }else{
                    vm.buttonSave = false;
                }
            }
        }
    }

    function flightTimeModelAircraftCtrl($stateParams, flightTimeService, timeService,modelAircraft,flightTimes,
                                         takeOffCapacities, toastr, $translate){
        var vm = this;
        vm.makerId = $stateParams.makerId;
        vm.modelAircraftId = $stateParams.modelAircraftId;
        vm.modelAircraft = modelAircraft.data;
        vm.flightTimes = [];
        vm.times = [];
        vm.takeOffCapacities = takeOffCapacities;

        getFlightTimes(flightTimes);

        function getFlightTimes(flightTimes){
            if(flightTimes.data._embedded){
                angular.forEach(flightTimes.data._embedded.flightTimes, function(flightTime){
                    flightTime.time = timeService.convertTimeToHourMinutes(flightTime.time)
                    vm.times.push({'open': false});
                });
                vm.flightTimes = flightTimes.data._embedded.flightTimes;
            }
        }
        fillArrayButtonFT()
        fillArrayButtonTOC();
        vm.oldFlightTimes = angular.copy(vm.flightTimes);
        vm.oldTakeOffCapacities = angular.copy(vm.takeOffCapacities);

        vm.saveSegmentFlightTime = function(isValid, segmentFlightTime){
            if(isValid){
                segmentFlightTime.time = timeService.convertTimeToHourMinutesZero(segmentFlightTime.time);
                flightTimeService.saveFlightTime(segmentFlightTime)
                    .then(function(){
                        segmentFlightTime.time = timeService.convertTimeToHourMinutes(segmentFlightTime.time);
                    });
            }
        }

        vm.saveTakeOffCapacity = function(isValid, takeOffCapacity){
            if(isValid){
                if(takeOffCapacity.takeOffCapacity > vm.modelAircraft.capacity) {
                    toastr.error($translate.instant('air.modelAircraft.maxTotal', {name: takeOffCapacity.takeOffCapacity, max:vm.modelAircraft.capacity}));
                } else {
                    flightTimeService.saveTakeOffCapacity(takeOffCapacity);
                }
            }
        }

        vm.changeFT = function(index){
            vm.buttonSaveFT[index] = false;
            var pos = vm.flightTimes[index].time.indexOf(":");
            var posOld = vm.oldFlightTimes[index].time.indexOf(":");
            if(parseInt(vm.flightTimes[index].time.substring(0,pos)) == parseInt(vm.oldFlightTimes[index].time.substring(0,posOld)) &&
                parseInt(vm.flightTimes[index].time.substring(pos+1)) == parseInt(vm.oldFlightTimes[index].time.substring(posOld+1))){
                vm.buttonSaveFT[index] = true;
            }else{
                vm.buttonSaveFT[index] = false;
            }
        }

        vm.changeTOC = function(index){
            if(vm.takeOffCapacities[index].takeOffCapacity == vm.oldTakeOffCapacities[index].takeOffCapacity){
                vm.buttonSaveTOC[index] = true;
            }else{
                vm.buttonSaveTOC[index] = false;
            }
        }

        function fillArrayButtonFT(){
            vm.buttonSaveFT = [];
            for(var i=0; i<vm.flightTimes.length; i++){
                vm.buttonSaveFT[i] = true;
            }
        }

        function fillArrayButtonTOC(){
            vm.buttonSaveTOC = [];
            for(var i=0; i<vm.takeOffCapacities.length; i++){
                vm.buttonSaveTOC[i] = true;
            }
        }
    }

    function deleteModelAircraftController($uibModalInstance, modelAircraft, modelAircraftService){
        var vm = this;
        vm.modelAircraft = modelAircraft.data;
        vm.name = vm.modelAircraft.name;

        vm.deleteModelAircraft = function(){
            modelAircraftService.deleteModelAircraft(vm.modelAircraft.makerId, vm.modelAircraft.modelAircraftId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalAddMakerController($uibModalInstance, makerService){
        var vm = this;

        vm.addingMaker = function(isValid, maker){
            makerService.saveMaker(maker)
                .then(function(responseMaker){
                    $uibModalInstance.close({maker: responseMaker.data});
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function formatTime(time, type){
        var newTimeSplit = time.split(":"),
            updateTime = '0:00';

        if(type == 1){
            updateTime = newTimeSplit[0] + ":" + newTimeSplit[1];
            if(newTimeSplit[0].length > 1){
                updateTime = formatTimeParse(updateTime);
            }
        }else if(type == 2){
            updateTime = newTimeSplit[0] + ":" + newTimeSplit[1];
        } else{
            updateTime = newTimeSplit[0] + ":" + newTimeSplit[1] + ":00";
        }
        return updateTime;
    }

    function formatTimeParse(time){
        var splitTime = time.split(':'),
            splitTimeCharAt = parseInt(splitTime[0].charAt(0)),
            newTime = time;

        if(splitTimeCharAt == 0){
            newTime = time.slice(1)
        }
        return newTime;
    }
})();
